<template>
  <div>
    <label>
      <slot name="label"></slot>
    </label>
    <currency-input
      v-model="inputVal"
      v-focus="focus"
      v-on:keydown.enter.prevent
      v-tooltip="{content:tooltipContent, placement:'bottom'}"
    />
    <transition name="fade">
      <div
        class="error"
        v-if="valid.$invalid && showError && valid.$params.between.max > 1"
      >
        {{$t('message.misc.between')}} 1 {{$t('message.misc.and')}} {{ valid.$params.between.max | locale }}
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["value", "valid", "errorMessage", "showError", "focus", "tooltipContent"],
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
